import RoleList from "../administration/RoleList";
import NotFound from "../other/NotFound";
import RoleFormPage from "./RoleFormPage";

const routes = [
    {path : 'company/:company/bots/list', component : () => <RoleList/>, isSidebar : true, isPublic : false},
    // {path : 'administration/role/create', component: () => <RoleFormPage/>, isSidebar : true, isPublic : false},
    // {path : 'administration/role/update', component: (data,type) => <RoleFormPage data={data} type={type}/>, isSidebar : true, isPublic : false},
    {path : '*', component: () => <NotFound/>, isPublic : true, isSidebar : false},
]

export default routes;